import useAppSettings from "@/hooks/useAppSettings";
import { createContext } from "react"

export interface IAppSettingsContext extends ReturnType<typeof useAppSettings> {
}

export const AppSettingsContext = createContext<IAppSettingsContext>({
    data: undefined,
    loading: false,
    validating: false,
    error: undefined,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined }
});

export default AppSettingsContext;